import { render, staticRenderFns } from "./product-page-routes.vue?vue&type=template&id=4dfe7460&scoped=true&"
import script from "./product-page-routes.vue?vue&type=script&lang=js&"
export * from "./product-page-routes.vue?vue&type=script&lang=js&"
import style0 from "./product-page-routes.vue?vue&type=style&index=0&id=4dfe7460&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfe7460",
  null
  
)

export default component.exports